<template>
  <el-form-item :label="`${label || ''}${viewMode && !!label ? '：' : ''}`" :prop="keyName" :label-width="labelWidth"
    class="item" :class="[viewMode ? 'view' : '', config.className]">
    <!-- 主体内容：查看模式不显示 -->
    <div v-if="!viewMode" class="content">
      <!-- 文本、数字、文本域控件 -->
      <el-input v-if="['text', 'number', 'textarea'].includes(type)" v-model="value" :type="type"
        :placeholder="placeholder || '请填写'" :disabled="disabled || config.disabled" :cols="cols" :rows="rows"
        @change="$change" @input="$input" @focus="onFocus" @blur="onBlur"></el-input>

      <div class="olist" v-if="type === 'text' && options && options.length">
        <div class="item" v-for="(n) in options" :key="n.value" @click="selectItem(n.data)">
          {{ n.label }}
        </div>
      </div>

      <!-- 带提示文本输入控件 -->
      <el-autocomplete v-if="type === 'textSelect'" v-model="value" :fetch-suggestions="querySearchAsync"
        :placeholder="placeholder || '请填写'" @select="handleSelect"></el-autocomplete>

      <!-- 单选控件 -->
      <el-radio-group class="el-input" v-if="type === 'radio'" v-model="value" @change="$change"
        :disabled="disabled || config.disabled">
        <el-radio v-for="(n, i) in options" :key="n.label + i" :label="n.value">
          {{ n.label }}
        </el-radio>
      </el-radio-group>

      <!-- 下拉选择 -->
      <el-select v-if="type === 'select'" v-model="value" :placeholder="placeholder || '请选择'" @change="$change"
        @focus="onFocus" filterable :multiple="multiple" :disabled="disabled || config.disabled"
        :class="config.className" :popper-class="config.popperClassName" :clearable="config.clearable"
        :collapse-tags="config.collapseTags">
        <el-option v-for="(n, i) in options" :key="n.label + i" :label="n.label" :value="n.value" :class="n.className"
          :disabled="n.disabled">
        </el-option>
      </el-select>

      <!-- 日期/时间控件 -->
      <el-date-picker v-if="[
        'date',
        'week',
        'month',
        'year',
        'dates',
        'datetime',
        'datetimerange',
        'daterange',
        'monthrange',
      ].includes(type)
      " v-model="value" :type="type" :placeholder="placeholder || '选择时间'" :disabled="disabled || config.disabled"
        range-separator="至" :start-placeholder="config.StartPlaceholder || '开始时间'"
        :end-placeholder="config.EndPlaceholder || '结束时间'" :picker-options="config.pickerOptions" @change="$datechange">
      </el-date-picker>

      <!-- 密码控件 -->
      <el-input v-if="type === 'password'" v-model="value" :placeholder="placeholder || '默认密码123456'" show-password
        @change="$change"></el-input>

      <!-- 文件上传控件 -->
      <el-upload v-if="type === 'file'" class="upload" :class="[!config.url ? 'upload' : '']"
        :action="`${IP}/fleet/base/${config.url || 'webupload'}`" :before-upload="beforeUpload"
        :on-success="uploadSuccess" :on-change="onFileChange" :on-error="uploadError" :on-preview="handlePreview"
        :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList"
        :list-type="config.listType ? 'text' : 'picture'" :multiple="config.max - 1 != 0" :limit="config.max"
        :disabled="disabled" :data="ortherParams" :accept="config.accept || '.png, .jpg, .jpeg, .gif, .webp, .bmp'"
        :auto-upload="!config.accept">
        <div class="btnbox">
          <el-button size="small" type="primary">{{ config.btnTxt || '选择图片' }}</el-button>

          <div v-if="config.tips && !viewMode" slot="tip" class="el-upload__tip">{{ config.tips }}</div>
        </div>

        <div v-if="!config.url" class="imgbox" slot="file" slot-scope="{file}" v-loading="fileLoad[file.name]">
          <el-image width="100%" :src="file.url" :preview-src-list="srcList"></el-image>
          <i class="el-icon-close" @click="onRemove(file)"></i>
        </div>
      </el-upload>

      <!-- 控件后缀（单位） -->
      <div v-if="config.unit" class="unit">{{ config.unit }}</div>

      <!-- 控件后插槽 -->
      <slot name="end"></slot>
    </div>

    <!-- 控件下方提示文字 -->
    <div v-if="config.tips && (type !== 'file') && !viewMode" class="tips">{{ config.tips }}</div>

    <!-- 查看模式普通文本显示 -->
    <div v-if="viewMode && !['file', 'datetimerange', 'daterange', 'monthrange',].includes(type)"
      class="el-input viewMode">{{ value || '-' }}<!-- 换行会产生空格 -->
      <span v-if="config.unit" class="unit">{{ config.unit }}</span>
    </div>

    <!-- 查看模式时间区域选择器显示 -->
    <div v-if="viewMode && ['datetimerange', 'daterange', 'monthrange',].includes(type)" class="el-input">
      <!-- {{ value[0] }} 至 {{ value[1] }} -->
      {{ value && value.length > 0 ? value[0] + ' 至 ' + value[1] : '' }}
    </div>

    <!-- 查看模式图片显示 -->
    <div class="showUpload el-input" v-if="viewMode && type == 'file'">
      <div class="showimg" v-for="(c, i) in fileList" :key="'viewImg' + i">
        <!-- <img :src="c.url" alt=""> -->

        <el-image width="100%" :src="c.url" :preview-src-list="srcList"></el-image>
      </div>
      <div class="txt" v-if="!fileList.length">-</div>
    </div>

    <!-- 图片详情 -->
    <el-dialog :visible.sync="dialogVisible" title="图片详情">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </el-form-item>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FormItem",
  props: {
    options: Array,
    config: Object,
    labelWidth: String,
    inputValue: [String, Array, Object, Number, Boolean],
    disabled: Boolean,
    viewMode: Boolean,
  },
  data() {
    return {
      fileLoad: {},
      loading: false,
      dialogImageUrl: '',
      dialogVisible: false,
      disabledd: false,
      type: this.config.type,
      label: this.config.label,
      keyName: this.config.keyName,
      placeholder: this.config.placeholder || this.config.err,
      multiple: this.config.multiple,
      cols: this.config.cols,
      rows: this.config.rows,
      value: this.inputValue,
      fileList: [],
      files: [],
      srcList: [],
      ortherParams: this.config.ptype ? { type: this.config.ptype } : {},
      selected: false,
    };
  },
  computed: {
    ...mapState([
      'IP',
    ]),
  },
  watch: {
    value: {
      deep: true,
      handler(v) {
        // 有选项不触发搜索
        if (this.type === 'textSelect') {
          // if (this.options && !this.options.length) {
          //   // console.log(`触发了 ${this.name} value changed`, v)
          //   this.$emit("formChange", this.config.name, v);
          // }
          // console.log(v)
          this.$emit("onChange", {
            key: this.keyName,
            value: v,
          });
        }
      },
    },
    inputValue: {
      deep: true,
      handler(newVal) {
        // console.log(`input '${this.keyName}' value is '${newVal}'`);
        this.value = newVal;
        if (this.type === 'file' && newVal != null && newVal != '') {
          // console.log(this.keyName, typeof newVal, newVal)
          // console.log(newVal, typeof newVal)
          if (Array.isArray(newVal)) {
            this.fileList = [...newVal]
            this.srcList = newVal.map(v => v.url)
          } else if (typeof newVal === 'string') {
            this.fileList = [{ url: newVal }]
            this.srcList = [newVal]
          }
          // console.log(this.fileList)
        } else if (this.type === 'file' && newVal == null) {
          this.fileList = []
          this.srcList = []
        }
      },
    },
    options: {
      deep: true,
      handler(newVal) {
        // console.log(this.keyName, this.value)
        // console.log(newVal)
        newVal.map(v => {
          if (v.value == this.value) {
            this.value = v.label
          }
        })
      },
    },
    config: {
      deep: true,
      handler(newVal) {
        // console.log(this.keyName, 'new config', newVal)
        this.config = newVal
      },
    },
  },
  methods: {
    querySearchAsync(queryString, cb) {
      // console.log('queryString', queryString)
      let dataList = this.options;
      var results = queryString
        ? dataList.filter(this.createFilter(queryString))
        : dataList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      // console.log('queryString', queryString)
      return (dataList) => {
        // console.log('dataList', dataList)
        return dataList.value
          .toString()
          .toLowerCase()
          .includes(queryString.toLowerCase());
      };
    },
    handleSelect(item) {
      console.log('select', { ...item });
      this.$emit("onChange", {
        key: this.keyName,
        value: item.value,
      });
      // this.$emit("onSelect", {
      //   key: this.keyName,
      //   value: item,
      // });
    },
    onFocus() {
      this.$emit("onFocus", {
        key: this.keyName,
      });
    },
    $input(v) {
      // console.log(this.keyName, v, typeof v);
      this.$emit("onInput", {
        key: this.keyName,
        value: v,
      });
    },
    $change(v) {
      // console.log(this.keyName, v, typeof v);
      // 空字符串存到后台自动变成0，这里给个默认值避免这种情况；但是值为0的时候就传0
      let value = v
      if (v === '') {
        value = null
      }
      this.$emit("onChange", {
        key: this.keyName,
        value,
      });
    },
    $datechange(v) {
      // console.log(v)
      if (!v) {
        this.$emit("onChange", {
          key: this.keyName,
          value: v,
        });
        return
      } else if (!v.length) {
        const y = v.getFullYear()
        let m = v.getMonth() + 1
        m > 9 ? null : m = '0' + m
        let d = v.getDate()
        d > 9 ? null : d = '0' + d
        let s = ''
        switch (this.type) {
          case 'year':
            s = `${y}`;
            break;
          case 'month':
            s = `${y}-${m}`;
            break;
          default:
            s = `${y}-${m}-${d}`;
            break;
        }
        // console.log(this.keyName, s);
        this.$emit("onChange", {
          key: this.keyName,
          value: s,
        });
      } else {
        const [val1, val2] = v
        const o1 = this.getDateStrObj(val1)
        const o2 = this.getDateStrObj(val2)
        // console.log(o1, o2)
        let s1 = `${o1.y}-${o1.m}-${o1.d}`
        let s2 = `${o2.y}-${o2.m}-${o2.d}`
        if (this.type === 'monthrange') {
          s1 = `${o1.y}-${o1.m}`
          s2 = `${o2.y}-${o2.m}`
        }
        // console.log(s1, s2)
        this.$emit("onChange", {
          key: this.keyName,
          value: [s1, s2],
        });
      }
    },
    beforeUpload(file) {
      // console.log('loading', file)
      // file.loading = true
      // console.log(file.loading)
      this.fileLoad[file.name] = true
    },
    onRemove(file) {
      // console.log({ ...file }, this.fileList, this.files);
      const idx = this.fileList.indexOf(file);
      // console.log(idx)
      this.fileList.splice(idx, 1);
      // console.log(this.fileList)
      // this.fileList = [...this.fileList]
      this.$emit("onChange", {
        key: this.keyName,
        value: this.fileList,
      });
    },
    handleRemove(file, list) {
      console.log(file, list);
      this.files = [...list];
      this.$emit("onChange", {
        key: this.keyName,
        value: this.files,
      });
    },
    handleExceed(file, list) {
      console.log(file, list);
      if (file) {
        this.$message({
          type: 'error',
          message: `最多上传${this.config.max}张图片！`
        });
      }
    },
    handlePreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    onFileChange(file, filelist) {
      // console.log({ ...file });
      // console.log(filelist);
      // console.log({ ...this.config })
      // 未设置accept则自动上传，不走这里
      if (!this.config.accept) return
      // 加载中
      this.fileLoad[file.name] = true
      // console.log(this.keyName)
      this.$emit("onFileChange", {
        key: this.keyName,
        value: {
          file,
          filelist,
        },
      });
    },
    uploadSuccess({ msg }, file, list) {
      this.fileLoad[file.name] = false
      // console.log(photo, msg);
      // console.log(file, list);
      if (msg === 1) {
        // console.log(this.files)
        // this.files = [...list]
        // this.$emit("onChange", {
        //   key: this.keyName,
        //   value: this.files,
        // });
        // console.log([...this.fileList])
        this.fileList = [...list]
        // console.log([...this.fileList])
        this.srcList = this.fileList.map(v => v.url)
        let val = this.fileList
        // console.log(val[0].response.photo)
        this.$emit("onChange", {
          key: this.keyName,
          value: val,
        });
      }
    },
    uploadError(err, file, list) {
      console.log(err, file, list)
      this.fileLoad[file.name] = false
    },
    selectItem(n) {
      this.selected = true
      this.$emit("onSelect", {
        key: this.keyName,
        value: n,
      });
    },
    onBlur() {
      // console.log('options', this.options)
      // console.log('selected', this.selected)
      setTimeout(() => {
        // console.log('options', this.options)
        // console.log('selected', this.selected)
        if (this.type == 'text' && this.options && this.options.length) {
          // console.log('not select')
          this.$emit("onSelect", {
            key: this.keyName,
            value: null,
          });
        }
      }, 100);
    },
  },
  updated() {
    // console.log(
    //   `update '${this.keyName}' from '${this.value}' to '${this.inputValue}'`
    // );
    if (this.viewMode && this.options && this.options.length) {
      // console.log(this.options)
      this.options.map(v => {
        if (v.value == this.value) {
          // console.log(v.label)
          this.value = v.label
        }
      })
    }
  },
  mounted() {
    // console.log(
    //   `mounted '${this.keyName}' from '${this.value}' to '${this.inputValue}'`
    // );
    if (this.type === 'file' && this.inputValue && this.inputValue != null) {
      // console.log(this.keyName, typeof newVal, newVal)
      // console.log(newVal)
      if (Array.isArray(this.inputValue)) {
        this.fileList = [...this.inputValue]
        this.srcList = this.inputValue.map(v => v.url)
      } else if (typeof this.inputValue === 'string') {
        this.fileList = [{ url: this.inputValue }]
        this.srcList = [this.inputValue]
      }
      // console.log(this.fileList)
    }
    // 查看模式下，默认有选项不需要请求的控件不回触发watch事件，直接匹配选项
    if (this.viewMode && this.options && this.options.length) {
      // console.log(this.options)
      this.options.map(v => {
        if (v.value == this.value) {
          this.value = v.label
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.item {
  &.view {
    /deep/ .el-form-item__label {
      padding: 0;

      &::before {
        display: none;
      }
    }
  }

  &.el-form-item {
    &.unton {
      width: 1000px;
    }

    &.block {
      width: 100%;
      padding-right: 0;
      margin-right: 0;
    }
  }

  &.order_remark {
    /deep/ .el-form-item__content {
      .el-textarea {
        .el-textarea__inner {
          resize: none;
          box-sizing: border-box;
          overflow: hidden;
          min-height: 40px !important;
          // line-height: 40px;
          padding: 7px 15px;
          // width: 100%;
          width: 300px;
        }
      }
    }
  }

  /deep/ .el-form-item__content {
    .el-form-item__error {
      padding-left: 15px;
    }

    .el-date-editor {
      &.el-range-editor {
        width: 250px;
      }

      .el-range-separator {
        width: 20px;
      }
    }

    .el-input {

      &.upload {
        width: 100%;
      }

      &.showUpload {
        width: 100%;
      }

      &.viewMode {
        /* 保留换行符 */
        white-space: pre-wrap;
        line-height: 20px;
        padding: 10px 0;
        word-wrap: break-word;
        /* 兼容写法 */
        overflow-wrap: break-word;
        /* 标准写法 */
      }
    }

    .el-textarea__inner {
      font-family: "Microsoft Yahei";
    }
  }

  .upload {
    min-width: 300px;

    .btnbox {
      display: flex;
      align-items: center;

      /deep/ .el-button {
        height: 32px;

        span {
          line-height: 14px;
        }
      }

      .el-upload__tip {
        // position: absolute;
        // left: 90px;
        // top: 0;
        // margin: 0;
        color: #FF5722;
        margin-left: 10px;
        margin-top: 0;
        text-align: left;
      }
    }

    /deep/ .el-upload-list {
      display: flex;
      flex-wrap: wrap;

      li {
        margin: 10px 10px 0 0;
        padding-right: 0;
        width: 0;
        // cursor: pointer;
        position: relative;

        &.el-upload-list__item {
          transition: none;
        }

        .el-upload-list__item-name {
          position: absolute;
          left: 10px;
          top: 10px;
          padding: 0;
          margin: 0;
          width: 70px;
          height: 70px;
          z-index: 5;
          text-indent: -2000px;
        }

        img {
          z-index: 0;
        }

        .imgbox {
          width: 90px;
          height: 90px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;

          .el-image {
            width: 70px;
            height: 70px;
          }
        }
      }
    }
  }

  .tips {
    color: #E6A23C;
    line-height: 16px;
    font-size: 12px;
    margin: 5px 15px;
  }
}


.content {
  display: flex;

  .el-radio-group {
    height: 40px;
    display: flex;
    align-items: center;
  }

  .unit {
    margin-left: 10px;
  }

  .olist {
    position: absolute;
    left: 0;
    top: 48px;
    z-index: 9;
    background: #fff;
    border: 1px solid #e6e6e6;

    .item {
      width: 200px;
      height: 38px;
      line-height: 38px;
      cursor: pointer;
      padding: 0 10px;
    }
  }
}

.showUpload {
  display: flex;
  flex-wrap: wrap;

  .showimg {
    width: 92px;
    height: 92px;
    overflow: hidden;
    border-radius: 6px;
    margin: 0 10px 10px 0;
    border: 1px solid #c0ccda;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
    }
  }
}
</style>
